import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class BusinessPurpose extends Enum {
  key!: string;
  value!: string;
  displayValue!: string;

  static OPERATING_COMPANY: BusinessPurpose = {
    key: 'operating_company',
    get value(): string {
      return Lang.t('asset.operating-company-most-common');
    },
    get displayValue(): string {
      return Lang.t('asset.operating-company');
    }
  };

  static HOLDING_COMPANY: BusinessPurpose = {
    key: 'holding_company',
    get value(): string {
      return Lang.t('asset.holding-company');
    },
    get displayValue(): string {
      return this.value;
    }
  };

  static INVESTMENT: BusinessPurpose = {
    key: 'investment',
    get value(): string {
      return Lang.t('asset.investment');
    },
    get displayValue(): string {
      return this.value;
    }
  };
}
